import React from 'react'
import PropTypes from 'prop-types'

import MainInputComponent from '../../main-input-component/MainInputComponent'
import GuidedInput from '../../inputs/guide-input-component/GuidedInput'
import MainCardUtils from '../../../utils/MainCardUtils'

import Data from '../../../data/Data'
import Validate from '../../../services/validate-service/Validate'

import { Row, Col } from 'shards-react'

const MainCardComponent = props => {
    const {
        actions,
        options,
        options: { isEditScreen },
        handleInput,
        miniApp,
    } = props

    const infos = isEditScreen ? MainCardUtils.getEditInfoInputs() : MainCardUtils.getRegisterInfoInputs()

    const showerror = infoName => {
        return Boolean(options.miniApp[infoName] && !Validate.isValidInput(infoName, options.miniApp[infoName]))
    }

    return (
        <React.Fragment>
            <Row>
                <Col sm="12" md="12" lg="12">
                    <MainInputComponent
                        actions={actions}
                        handleInput={handleInput}
                        options={options}
                        name={'name'}
                        advicetext={Data.getAdviceTextFromInputs().name}
                        inputPlaceholder={'Nome'}
                        inputLabel={'Nome*'}
                        showText={true}
                        readOnly={isEditScreen && !options.hasEditMiniAppScope}
                    />
                </Col>
            </Row>
            <hr />
            {infos.map((info, index) => (
                <React.Fragment key={index}>
                    <Row>
                        <Col sm="12" md="12" lg="12">
                            <GuidedInput
                                options={options}
                                inputLabel={info.inputLabel}
                                inputPlaceholder={info.inputPlaceholder}
                                name={info.name}
                                advicetext={info.text}
                                helptext={info.description}
                                onChange={handleInput}
                                valid={Validate.isValidInput(info.name, options.miniApp[info.name])}
                                invalid={
                                    isEditScreen
                                        ? !Validate.isValidInput(info.name, options.miniApp[info.name])
                                        : (options.showInputError &&
                                              !Validate.isValidInput(info.name, options.miniApp[info.name])) ||
                                          (options.miniApp[info.name].length >= 1 &&
                                              !Validate.isValidInput(info.name, options.miniApp[info.name]))
                                }
                                value={miniApp[info.name] || ''}
                                showerror={showerror(info.name)}
                                readOnly={isEditScreen && !options.hasEditMiniAppScope}
                            />
                        </Col>
                    </Row>
                    <hr />
                </React.Fragment>
            ))}
        </React.Fragment>
    )
}

MainCardComponent.propTypes = {
    actions: PropTypes.object,
    options: PropTypes.object,
    screen: PropTypes.string,
    handleInput: PropTypes.func,
    miniApp: PropTypes.object,
    readOnly: PropTypes.bool,
}

export default MainCardComponent
